export const nameMinLength = 5;
export const nameMaxLength = 30;
export const planLimit = 200;
export const taskLimit = 15;
export const bucket_url = "https://bucket.musicators.com/";

export const googleClientSecret = "AaDB6GqdXgHSYrkq5fAi0y7x";
